(function ($) {
    $(() => {

        /* Remove error on change */
        $('#call_back').change(function (event) {
            event.preventDefault();
            const $parent = $('.js-phone-input').parents('.form-group');
            $parent.find('.form-error').text('');
            $parent.find('input').removeClass('is-invalid');
        });

        $('.subject_checkbox').click(function (event) {
            if ($(this).is(':checked')) {
                $(this).attr('value', 'Igen');
            } else {
                $(this).attr('value', 'Nem');
            }
        });

        $('.js-contact-success-modal').click(function (event) {
            if (event.target === this) {
                $('.js-contact-success-modal').hide();
            }
        });

        $('.js-close-modal').click(function (e) {
            e.preventDefault();
            console.log($(this).parents('.contact-success-modal__overlay'));
            $(this).parents('.contact-success-modal__overlay').hide();

            if ($(this).hasClass('js-gateway-button')) {
                $('.js-contanct-form').get(0).scrollIntoView({ behavior: "smooth" });
            }

        });

        if ($('#contact-form').length) {
            $('#request_exist_plan').change(function () {
                $('.js-file-upload').toggleClass('active');
            })
        }

        $('.js-request-exist-plan').change(function () {
            $('#files').removeClass('is-invalid');
            $('#form-error-files').text('');
        });

        $('#contact-form').submit(function (event) {
            event.preventDefault();

            const $this = $(this);

            $this.find('.form-error').text('');

            $this.find('input').removeClass('is-invalid');

            $this.find('.btn[type="submit"]').attr('disabled', true);

            const params = $this.serializeArray();
            const formData = new FormData();
            const images = $this.find('.js-request-exist-plan')[0].files;

            Object.keys(params).forEach(key => {
                formData.append(params[key].name, params[key].value);
            })

            if (images) {
                $.each(images, function (i, image) {
                    formData.append('image-' + i, image);
                });
            }

            formData.append('action', 'contact_form');

            $.ajax({
                url: localize.ajaxurl,
                type: "POST",
                dataType: "json",
                processData: false,
                contentType: false,
                context: this,
                data: formData,
            })
                .done(response => {
                    if (response.status === 'error') {
                        Object.entries(response.errors).forEach(([field, error]) => {
                            $(`#form-error-${field}`).text(error);
                            $(`#${field}`).addClass('is-invalid');
                        });
                    }

                    if (response.status === 'success') {
                        $this.trigger('reset');
                        $('.js-contact-success-modal').show();
                        $('.js-file-upload').removeClass('active');

                        const refresh = `${window.location.protocol}//${window.location.host}${window.location.pathname}?form_submit=true`;
                        window.history.pushState({ path: refresh }, '', refresh);
                    }
                })
                .always(() => {
                    $this.find('.btn[type="submit"]').attr('disabled', false);
                });
        });

        $('.contact-landing-block__thanks').hide();

        $('#contact-landing-form').submit(function (event) {
            event.preventDefault();

            const $this = $(this);

            $this.find('.form-error').text('');

            $this.find('input').removeClass('is-invalid');

            $this.find('.btn[type="submit"]').attr('disabled', true);

            const data = $this.serializeArray();

            $.ajax({
                type: 'post',
                dataType: 'json',
                url: localize.ajaxurl,
                data: {
                    action: 'contact_landing_form',
                    data
                }
            })
                .done(response => {
                    if (response.status === 'error') {
                        Object.entries(response.errors).forEach(([field, error]) => {
                            $(`#form-error-${field}`).text(error);
                            $(`#${field}`).addClass('is-invalid');
                        });
                    }

                    if (response.status === 'success') {
                        $this.trigger('reset');
                        $('.contact-landing-block__thanks').show();
                        $('.contact-landing-block__form').hide();

                        const refresh = `${window.location.protocol}//${window.location.host}${window.location.pathname}?form_submit=true`;
                        window.history.pushState({ path: refresh }, '', refresh);
                    }
                })
                .always(() => {
                    $this.find('.btn[type="submit"]').attr('disabled', false);
                });
        });

        $('.newsletter-subscription_success').hide();

        $('#newsletter-form').submit(function (event) {
            event.preventDefault();

            const $this = $(this);

            $this.find('.form-error').text('');

            $this.find('input').removeClass('is-invalid');

            $this.find('.btn[type="submit"]').attr('disabled', true);

            const data = $this.serializeArray();

            $.ajax({
                type: 'post',
                dataType: 'json',
                url: localize.ajaxurl,
                data: {
                    action: 'newsletter_subscription_success',
                    data
                }
            })
                .done(response => {
                    if (response.status === 'error') {
                        Object.entries(response.errors).forEach(([field, error]) => {
                            $(`#form-error-${field}`).text(error);
                            $(`#${field}`).addClass('is-invalid');
                        });
                    }

                    if (response.status === 'success') {
                        $this.trigger('reset');
                        $('.newsletter-subscription_success').show();
                        $('.newsletter-subscription').hide();

                        const refresh = `${window.location.protocol}//${window.location.host}${window.location.pathname}?form_submit=true`;
                        window.history.pushState({ path: refresh }, '', refresh);
                    }
                })
                .always(() => {
                    $this.find('.btn[type="submit"]').attr('disabled', false);
                });
        });
    });
})(jQuery);
